import ErrorManager from '../Helpers/ErrorManager';
import { getCopy } from '../helpers';
import { isEmpty } from '../Helpers/validationsHelper';
import moment from 'moment';

class GenerateRequestEfosProcess {
    constructor(data, taxId) {
        this.data = getCopy(data);
        this.data = {
            ...this.data,         
            TaxId: taxId,
            RequestType: 'Metadata',
            GeneratePDF: false,
        }
    }

    getDataToSend() {
        this.validate(this.data);
        const result = this.formatDates(this.data);
        return result;
    }

    validate(data) {
        const { StartDate, EndDate, TaxId, DocumentType, RequestType } = data;
        if (TaxId === '') {
            ErrorManager.throwError('Favor de Seleccionar un RFC');
        }
        if (isEmpty(StartDate) || isEmpty(EndDate)) {
            ErrorManager.throwError('Favor de seleccionar un rango de fechas para realizar la descarga');
        }
        if(isEmpty(DocumentType)) {
            ErrorManager.throwError('Solo pueden usarse documentos de tipo recepción o emisión');
        }
        if(RequestType !== 'Metadata') {
            ErrorManager.throwError('Solo pueden usarse consulta por metadada');
        }
    }

    formatDates(data) {
        const copy = getCopy(data);
        const result = {
            ...copy,
            StartDate: moment(copy.StartDate, 'DD-MM-YYYY').format('MM-DD-YYYY'),
            EndDate: moment(copy.EndDate, 'DD-MM-YYYY').format('MM-DD-YYYY'),
        };
        return result;
    }
}

export default GenerateRequestEfosProcess;